import { assign } from 'xstate';

import { type ReorderEventParams, type ReorderMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const storeResponse: ReorderMachineAction<ReorderEventParams> = assign(
  ({ context }, params) => ({
    response: params.reorderEvent.response ?? context.response,
  }),
);
